import React, { useState } from "react";

export default function CalcTemperature(props) {
  let [unit, setUnit] = useState(props.unit);

  function showCelsius() {
    setUnit("metric");
  }

  function showFahrenheit() {
    setUnit("fahrenheit");
  }

  function calcFahrenheit() {
    return Math.round((props.temp * 9) / 5 + 32);
  }

  if (unit === "metric") {
    return (
      <span className="temperature">
        <h1>{props.temp}</h1>
        <span className="units">
          °C|
          <a href="#" onClick={showFahrenheit}>
            °F
          </a>
        </span>
      </span>
    );
  } else {
    return (
      <span className="temperature">
        <h1>{calcFahrenheit()}</h1>
        <span className="units">
          <a href="#" onClick={showCelsius}>
            °C
          </a>
          |°F
        </span>
      </span>
    );
  }
}
